<template>
  <div class="certification-dialog">
    <el-dialog v-model="showDialog">
      <div class="f-center f-column">
        <img class="logo m-b-20" src="@/view/certification/assets/logo.png" alt />
        <div class="m-b-40">恭喜您,录入完成</div>
        <div class="f-between w-100b m-b-25">
          <div class="w-160">
            <ion-button class="w-160" color="primary">开始试用</ion-button>
          </div>
          <div class="w-160">
            <ion-button class="w-160" shape="round" fill="outline">立即认证</ion-button>
          </div>
        </div>
        <div>
          <span>试用期3天，完成认证后您将获得</span>
          <ion-label color="primary">3个月</ion-label>
          <span>面试使用期</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import router from '@/router'
import Camera from '@/view/certification/components/Camera.vue'

export default {
  props: {
    title: String,
    modelValue: String,
  },
  setup(props, { emit }) {
    
    console.log(props, props.modelValue)

    const showDialog = ref(props.modelValue)
    watch(showDialog, (v) => emit('update:modelValue', v))
    watch(() => props.modelValue, (v) => showDialog.value = v)

    return { Camera }
  },
  components: {  },
}
</script>

<style lang="scss">

.certification-dialog {
}
</style>